import Firebase from 'firebase/app'
// 'firebase/compat/app'
import 'firebase/auth'
import 'firebase/database'
// import "firebase/remote-config";
// import { getRemoteConfig } from "firebase/remote-config";

// const remoteConfig = getRemoteConfig();
// import 'firebase/storage'
// import 'firebase/compat/messaging'
// import { getMessaging } from "firebase/messaging";

// const messaging = getMessaging();
// import 'firebase/firestore';
import * as VueFire from 'vuefire'

// let app;
let firebaseConfig = {
  apiKey: "AIzaSyCZ9ZOb7jXUirpySnyET8CTLcXcH1zsDmI",
  authDomain: "slink-64a53.firebaseapp.com",
  databaseURL: "https://slink-64a53.firebaseio.com",
  projectId: "slink-64a53",
  storageBucket: "slink-64a53.appspot.com",
  messagingSenderId: "490970029935",
  appId: "1:490970029935:web:6ec47cc7e30bd144",
  measurementId: "G-GK4715EJD7"
}
export const fb = Firebase.initializeApp(firebaseConfig)
export const analytics = Firebase.analytics();
// export const snfb = Firebase.firestore();
// export const messaging = Firebase.messaging();
// console.log('firebase initialised from firebaseconfig.js')


// WEBPACK FOOTER //
// ./src/components/firebaseconfig.js